const parseAmount = (value) => {
  if (value == null || value === "") return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;

  let raw = String(value).trim().replace(/\u00a0/g, "").replace(/\s/g, "");
  if (!raw) return null;

  if (raw.includes(",") && raw.includes(".")) {
    raw = raw.replace(/\./g, "").replace(",", ".");
  } else if (raw.includes(",")) {
    raw = raw.replace(",", ".");
  }

  const number = Number(raw);
  return Number.isFinite(number) ? number : null;
};

const isWholeAmount = (number) => Math.abs(number - Math.round(number)) < 1e-9;

const formatGroupedDots = (integer) => (
  String(integer).replace(/\B(?=(\d{3})+(?!\d))/g, ".")
);

const formatCs = (number, fractionDigits) => (
  new Intl.NumberFormat("cs-CZ", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: 2
  }).format(number)
);

/**
 * Celé číslo bez haléřů: usekne ",00".
 * 1250 → "1 250"
 * 1250,40 → "1 250,40"
 */
export const formatTrimZeroCents = (value) => {
  const number = parseAmount(value);
  if (number == null) return "";
  return formatCs(number, isWholeAmount(number) ? 0 : 2);
};

/**
 * Celé číslo bez haléřů: účetní zápis s čárkou a pomlčkou.
 * 1250 → "1.250,-"
 * 1250,40 → "1.250,40"
 */
export const formatDashIfWhole = (value) => {
  const number = parseAmount(value);
  if (number == null) return "";

  const sign = number < 0 ? "-" : "";
  const abs = Math.abs(number);

  if (isWholeAmount(abs)) {
    return `${sign}${formatGroupedDots(Math.round(abs))},-`;
  }

  const integer = Math.floor(abs + 1e-9);
  const cents = Math.round((abs - integer) * 100);
  return `${sign}${formatGroupedDots(integer)},${String(cents).padStart(2, "0")}`;
};
